import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
  useNavigate,
  useNavigationType,
} from "react-router-dom";
import { useEffect, useRef } from "react";
import { PROJECT_NAME } from "./constants";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Layout from "../src/components/Layout";
import Dashboard from "./pages/Dashboard";
import ProtectedRoute from "./protectedRoute";
import SignIn from "./pages/Signin";
import Profile from "./pages/profile";
import "./App.css";
import DeliveredOrderHistory from "./pages/Delivered_Orders_History";
import CustomerProfile from "./pages/Customer_Profile";
import Offers from "./pages/Offers";
import SignUp from "./pages/Signup";
import CompanyListPage from "./pages/CompanyList";
import AddressMaster from "./pages/Address_Master";
import Support from "./pages/Support";
import PurchaseHistory from "./pages/Purchase_History";
import NewOrder from "./pages/New_Order";
import NewOrderAddressList from "./pages/New_Order_Address_List";
import ChangeShop from "./pages/Change_Shop";
import OrderHistory from "./pages/Order_History";
import Ledger from "./pages/Ledger";
import DirectSignup from "./pages/DirectSignup";

function AppWrapper() {
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}

function App() {
  const location = useLocation();

  useEffect(() => {
    const projectName = PROJECT_NAME;

    switch (location.pathname) {
      case "/signin":
        document.title = projectName;
        break;
      case "/signup":
        document.title = `${projectName} - SignUp`;
        break;
      case "/dashboard":
        document.title = `${projectName} - Dashboard`;
        break;
      case "/profile":
        document.title = `${projectName} - Profile`;
        break;
      case "/customer_profile":
        document.title = `${projectName} - Customer Profile`;
        break;
      case "/delivered_orders_history":
        document.title = `${projectName} - Delivered Orders History`;
        break;
      case "/purchase_history":
        document.title = `${projectName} - Purchase History`;
        break;
      case "/ledger":
        document.title = `${projectName} - Ledger`;
        break;
      case "/order_history":
        document.title = `${projectName} - Order History`;
        break;
      case "/offers":
        document.title = `${projectName} - Offers`;
        break;
      case "/address_master":
        document.title = `${projectName} - Address Master`;
        break;
      case "/support":
        document.title = `${projectName} - Support`;
        break;
      case "/new_order":
        document.title = `${projectName} - Order List`;
        break;
      case "/address_list":
        document.title = `${projectName} - Address List`;
        break;
      case "/change_shop":
        document.title = `${projectName} - Change Shop`;
        break;
      default:
        if (location.pathname.startsWith("/directsignup")) {
          document.title = `${projectName} - Direct SignUp`;
        } else {
          document.title = projectName;
        }
    }
  }, [location.pathname]);

  const navigate = useNavigate();
  const navigationType = useNavigationType();

  const prevPathRef = useRef(null);

  useEffect(() => {
    // Detect browser BACK
    if (navigationType === "POP") {
      // If coming BACK from dashboard
      if (prevPathRef.current === "/dashboard") {
        navigate("/dashboard", {
          state: { flag: "show" },
          replace: true,
        });
      }
    }

    // Store current path for next navigation
    prevPathRef.current = location.pathname;
  }, [location.pathname, navigationType, navigate]);

  return (
    <>
      <div className="theme-teal">
        <Routes>
          {/* Redirect root to login */}
          <Route path="/" element={<Navigate to="/signin" />} />

          {/* LOGIN PAGE */}
          <Route path="/signin" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/directsignup/:companycode" element={<DirectSignup />} />
          <Route path="/company-list" element={<CompanyListPage />} />

          <Route
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/customer_profile" element={<CustomerProfile />} />
            <Route
              path="/delivered_orders_history"
              element={<DeliveredOrderHistory />}
            />
            <Route path="/purchase_history" element={<PurchaseHistory />} />
            <Route path="/order_history" element={<OrderHistory />} />
            <Route path="/ledger" element={<Ledger />} />
            <Route path="/offers" element={<Offers />} />
            <Route path="/address_master" element={<AddressMaster />} />
            <Route path="/support" element={<Support />} />
            <Route path="/new_order" element={<NewOrder />} />
            <Route path="/address_list" element={<NewOrderAddressList />} />
            <Route path="/change_shop" element={<ChangeShop />} />
          </Route>
        </Routes>
      </div>
    </>
  );
}

export default AppWrapper;
